import React, { Component } from 'react'

class RefundModel extends Component {
  state = {
    isLoading: false,
    refund_type: '',
    refund_amount: 0,
    comment_en: '',
    comment_ar: '',
  }

  handleChange = (event) => {
    if (event.target.name == 'refund_amount' && event.target.value > this.props.refundAmount) {
      this.setState({
        [event.target.name]: this.props.refundAmount,
      })
      return
    }

    this.setState({
      [event.target.name]: event.target.value,
    })
  }

  componentDidMount = () => {
    this.setState({
      refund_amount: this.props.refundAmount,
    })
  }

  render() {
    return (
      <div style={{ width: 800, paddingRight: 40 }}>
        <div className="header">
          <b>Refund Form</b>
        </div>
        <div className="body m-t-20">
          <div className="row">
            <div className="col-12">
              <div className="form-group row">
                <label className="col-3 col-form-label">Refund Type</label>
                <div className="col-9">
                  <select
                    name="refund_type"
                    className="form-control"
                    onChange={this.handleChange}
                    value={this.state.refund_type}
                  >
                    <option value="">Select Refund Type</option>
                    <option value={'account'}>Account</option>
                    <option value={'wallet'}>Wallet</option>
                    <option value={'expirable wallet'}>Expirable Wallet</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="col-12">
              <div className="form-group row">
                <label className="col-3 col-form-label">Refund Amount</label>
                <div className="col-9">
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Enter amount"
                    value={this.state.refund_amount}
                    name="refund_amount"
                    onChange={this.handleChange}
                    max={this.props.refundAmount}
                  />
                  <span className="text-danger">Max refundable amount - {this.props.refundAmount}</span>
                </div>
              </div>
            </div>
            <div className="col-12">
              <div className="form-group row">
                <label className="col-3 col-form-label">Comment: English</label>
                <div className="col-9">
                  <textarea
                    rows={3}
                    className="form-control"
                    onChange={this.handleChange}
                    name="comment_en"
                    id="comment_en"
                    maxLength={200}
                    placeholder=""
                    value={this.state.comment_en}
                  />
                </div>
              </div>
            </div>
            <div className="col-12">
              <div className="form-group row">
                <label className="col-3 col-form-label">Comment: Arabic</label>
                <div className="col-9">
                  <textarea
                    rows={3}
                    className="form-control"
                    onChange={this.handleChange}
                    name="comment_ar"
                    id="comment_ar"
                    maxLength={200}
                    placeholder=""
                    value={this.state.comment_ar}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="text-right col-6 offset-6">
              <button
                onClick={() => this.props.processRefund(this.state)}
                className="btn hor-grd btn-grd-inverse offset-1"
                disabled={this.state.refund_amount <= 0}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
export default RefundModel
